export default __webpack_public_path__ + "static/media/pexels.063f03ce.webp";